var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProofOfAddressDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25368_25060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25 29.7502H26.75",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20.7502C21.6569 20.7502 23 19.4071 23 17.7502C23 16.0934 21.6569 14.7502 20 14.7502C18.3431 14.7502 17 16.0934 17 17.7502C17 19.4071 18.3431 20.7502 20 20.7502Z",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 17.7502C27.5 24.5002 20 29.7502 20 29.7502C20 29.7502 12.5 24.5002 12.5 17.7502C12.5 15.7611 13.2902 13.8535 14.6967 12.4469C16.1032 11.0404 18.0109 10.2502 20 10.2502C21.9891 10.2502 23.8968 11.0404 25.3033 12.4469C26.7098 13.8535 27.5 15.7611 27.5 17.7502Z",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25368_25060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.00024)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofOfAddressDoc);
export default __webpack_public_path__ + "static/media/proofOfAddressDoc.fde22776ea9e8628b1da82743c402188.svg";
export { ForwardRef as ReactComponent };